import { z } from 'zod';

export const blendModeSchema = z.enum([
  'none',
  'multiply',
  'screen',
  'overlay',
  'darken',
  'lighten',
  'color-dodge',
  'color-burn',
  'hard-light',
  'soft-light',
  'difference',
  'exclusion',
  'hue',
  'saturation',
  'color',
  'luminosity',
]);

export type BlendMode = z.infer<typeof blendModeSchema>;

export const fadeSchema = z.enum([
  'none',
  'top',
  'bottom',
  'left',
  'right',
  'topRight',
  'topLeft',
  'bottomRight',
  'bottomLeft',
]);

export type Fade = z.infer<typeof fadeSchema>;

export const filterSchema = z.enum([
  'none',
  'blur',
  'sepia',
  'grayscale',
  'invert',
  'brighten',
  'darken',
  'vibrant',
  'muted',
  'duotone',
]);

export type Filter = z.infer<typeof filterSchema>;

export const textureSchema = z.enum(['none', 'grid-small', 'dots-small']);

export type Texture = z.infer<typeof textureSchema>;
